<script>
import ShareHealthVaultDialogBase from '@components/dialogs/safehaven/share-health-vault-dialog-base.vue'
import DeleteConfirmationDialog from '@components/delete-confirmation-dialog.vue'
import FilePreviewImage from '@components/file-preview-image.vue'
import FilePreviewPdf from '@components/file-preview-pdf.vue'
import UploadDocumentDialog from '@components/upload-document-dialog.vue'
import { healthVaultService } from '@/src/services/safehaven/HealthVaultService'
import { formatDateMoment } from '@utils/format-date'

export default {
  components: {
    ShareHealthVaultDialogBase,
    UploadDocumentDialog,
    DeleteConfirmationDialog,
    FilePreviewImage,
    FilePreviewPdf,
  },
  data() {
    return {
      headers: [
        {
          text: 'Document Name',
          value: 'document_name',
        },
        { text: 'Uploaded', value: 'document_uploaded_at' },
        { text: 'Tags', value: 'tags', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ],
      snackbar: false,
      documents: [],
      selected: [],
      loading: false,
      exportHealthVaultDoc: false,
      openUploadDialog: false,
      openDeleteDialog: false,
      selectedDocument: null,
      tags: [],
      selectedTitle: 'Show All',
      timeout: null,
      totalRecord: 0,
      totalPages: 0,
      isEdit: false,
      itemToEdit: null,
      acceptedTypes: ['jpg', 'jpeg', 'png'],
      itemToDelete: {
        document_list: [],
      },
      options: {},
      filterDetails: {
        page_count: 1,
        sort: {
          field: '',
          order: '',
        },
        filter: {
          field: '',
        },
      },
      pdfDialog: false,
      imageDialog: false,
      toPreview: null,
      extension: null,
      showTable: true,
    }
  },
  computed: {
    showBtnText() {
      return this.selectedTitle
    },
  },
  watch: {
    '$vuetify.breakpoint.mobile'(newValue) {
      if (newValue) {
        this.headers = [
          { text: '', value: 'actions', sortable: false },
          {
            text: 'Document Name',
            value: 'document_name',
          },
          { text: 'Uploaded', value: 'document_uploaded_at' },
          { text: 'Tags', value: 'tags', sortable: false },
        ]
      } else {
        this.headers = [
          {
            text: 'Document Name',
            value: 'document_name',
          },
          { text: 'Uploaded', value: 'document_uploaded_at' },
          { text: 'Tags', value: 'tags', sortable: false },
          { text: '', value: 'actions', sortable: false },
        ]
      }
    },
    selectedTitle() {
      this.filterDetails.filter.field =
        this.selectedTitle !== 'Show All' ? this.selectedTitle : ''
      this.filterDetails.page_count = 1
      this.documents = []
      this.getAllRecords()
    },
    selectedDocument(newValue) {
      if (newValue) this.openUploadDialog = true
    },
    options: {
      handler() {
        this.filterDetails.page_count = 1
        this.documents = []
        this.getAllRecords()
      },
      deep: true,
    },
  },
  mounted() {
    this.getTags()
    if (this.$vuetify.breakpoint.mobile) {
      this.headers = [
        { text: '', value: 'actions', sortable: false },
        {
          text: 'Document Name',
          value: 'document_name',
        },
        { text: 'Uploaded', value: 'document_uploaded_at' },
        { text: 'Tags', value: 'tags', sortable: false },
      ]
    } else {
      this.headers = [
        {
          text: 'Document Name',
          value: 'document_name',
        },
        { text: 'Uploaded', value: 'document_uploaded_at' },
        { text: 'Tags', value: 'tags', sortable: false },
        { text: '', value: 'actions', sortable: false },
      ]
    }
  },
  methods: {
    showDocuments() {
      this.exportHealthVaultDoc = true
    },
    formatDateMoment,
    editItem(item) {
      this.itemToEdit = item
      this.isEdit = true
      this.openUploadDialog = true
    },
    deleteMultipleItems(item) {
      if (item) {
        const data = {
          id: item.document_id,
          name: item.document_name,
        }
        this.itemToDelete.document_list.push(data)
        this.openDeleteDialog = true
      } else {
        this.selected.map((rec) => {
          const data = {
            id: rec.document_id,
            name: rec.document_name,
          }
          this.itemToDelete.document_list.push(data)
        })
        this.openDeleteDialog = true
      }
    },
    delete(document) {
      this.loading = true
      healthVaultService.deleteDocuments(document).then(
        (res) => {
          this.documents = []
          this.filterDetails.page_count = 1
          this.openDeleteDialog = false
          this.selected = []
          // eslint-disable-next-line no-unused-expressions
          this.itemToDelete = {
            document_list: [],
          }
          this.loading = false
          this.snackbar = true
          this.getAllRecords()
        },
        (err) => {
          this.loading = false
          console.warn(err.response.data)
        }
      )
    },
    boardSwitch(value) {
      this.selectedTitle = value.tag_name
    },
    getAllRecords() {
      this.loading = true
      const { sortBy, sortDesc } = this.options
      // eslint-disable-next-line
      this.filterDetails.sort.field = !sortBy.length
        ? 'document_uploaded_at'
        : sortBy[0]
      this.filterDetails.sort.order =
        sortBy.length && sortDesc.length
          ? sortDesc[0]
            ? 'desc'
            : 'asc'
          : 'desc'
      healthVaultService.getDocuments(this.filterDetails).then((res) => {
        if (!this.documents.length) {
          this.totalRecord = res.data.number_of_records
          this.totalPages = Math.ceil(this.totalRecord / 10)
          this.documents = res.data.records
          this.loading = false
        } else {
          this.loading = false
          this.documents = this.documents.concat(res.data.records)
        }
      })
    },
    getTags() {
      healthVaultService.getHealthVaultTags().then((res) => {
        this.tags = res.data.Tags
        this.tags.unshift({ id: 'showall', tag_name: 'Show All' })
      })
    },
    onScroll(e) {
      if (this.filterDetails.page_count < this.totalPages) {
        this.filterDetails.page_count = this.filterDetails.page_count + 1
        this.timeout && clearTimeout(this.timeout)

        this.timeout = setTimeout(() => {
          const { scrollTop } = e.target
          this.getAllRecords()

          this.$nextTick(() => {
            e.target.scrollTop = scrollTop
          })
        }, 20)
      }
    },
    closeUploadDialog() {
      this.selectedDocument = null
      this.itemToEdit = null
      this.openUploadDialog = false
      this.isEdit = false
      this.filterDetails.page_count = 1
      this.documents = []
      this.tags.unshift({ id: 'showall', tag_name: 'Show All' })
      this.getAllRecords()
    },
    closeDeleteDialog(action) {
      if (action === 'yes') {
        this.delete(this.itemToDelete)
      } else {
        // eslint-disable-next-line no-unused-expressions
        this.itemToDelete = {
          document_list: [],
        }
      }
    },
    preview(item) {
      const ext = item.document_name.split('.').pop()
      this.toPreview = item
      healthVaultService.getDocumentFiles(item.document_id).then((res) => {
        this.extension = res.data.file_name.split('.').pop()
        this.toPreview.url = res.data.file_url
        if (ext === 'pdf') {
          if (navigator.userAgent.indexOf('Safari') !== -1) {
            this.showTable = false
          }
          this.pdfDialog = true
        } else {
          if (this.acceptedTypes.includes(ext)) {
            this.imageDialog = true
          }
        }
      })
    },
    closeImageDialog() {
      this.toPreview = null
      this.extension = null
      this.imageDialog = false
    },
    closePDFDialog() {
      this.toPreview = null
      this.extension = null
      this.pdfDialog = false
      if (navigator.userAgent.indexOf('Safari') !== -1) {
        this.showTable = true
      }
    },
  },
}
</script>

<template>
  <v-row no-gutters class="my-auto pa-0">
    <v-dialog
      :value="imageDialog"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewImage
        v-if="imageDialog && toPreview && extension"
        :attachment-id="toPreview.document_id"
        :title="toPreview.document_name"
        :type="extension"
        :src="toPreview.url"
        :attachments="[]"
        resource="vault"
        @closeOverlay="closeImageDialog"
      />
    </v-dialog>
    <v-dialog
      :value="pdfDialog && toPreview && extension"
      :fullscreen="true"
      dark
      persistent
      no-click-animation
      transition="fade-transition"
    >
      <FilePreviewPdf
        v-if="pdfDialog"
        :attachment-id="toPreview.document_id"
        :attachments="[]"
        :src="toPreview.url"
        resource="vault"
        @closeOverlay="closePDFDialog"
      />
    </v-dialog>
    <v-col cols="12" md="12" sm="12" lg="12" xl="12" class="pr-10 mt-3">
      <label for="uploadedDocument" :class="$style.uploadBtn">
        <v-icon left :class="$style.uploadIcn"> mdi-upload </v-icon>
        Upload Document
      </label>
      <v-file-input
        id="uploadedDocument"
        v-model="selectedDocument"
        type="file"
        accept="image/*, .pdf"
        style="display: none"
      />
      <v-btn
        class="ma-2"
        :x-small="$vuetify.breakpoint.mobile"
        :class="['primary-btn', selected.length === 0 && 'disabled-btn']"
        :fab="$vuetify.breakpoint.mobile"
        @click="showDocuments"
      >
        <v-icon :left="!$vuetify.breakpoint.mobile"> mdi-share-variant </v-icon>
        <span v-if="!$vuetify.breakpoint.mobile">Share</span>
      </v-btn>
      <v-btn
        :x-small="$vuetify.breakpoint.mobile"
        :class="['primary-btn', selected.length === 0 && 'disabled-btn']"
        :fab="$vuetify.breakpoint.mobile"
        @click="deleteMultipleItems(null)"
      >
        <v-icon :left="!$vuetify.breakpoint.mobile"> mdi-delete </v-icon>
        <span v-if="!$vuetify.breakpoint.mobile">Delete</span>
      </v-btn>
      <v-menu
        transition="slide-y-transition"
        bottom
        left
        nudge-left="0"
        nudge-bottom="38"
        min-width="200"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            class="mt-3 pa-1"
            :class="[
              $style.txtBtn,
              $vuetify.breakpoint.mobile ? '' : 'float-right',
            ]"
            color="primary"
            text
            v-bind="attrs"
            v-on="on"
          >
            <v-icon left> mdi-filter </v-icon>
            {{ showBtnText }}
          </v-btn>
        </template>
        <v-list>
          <v-list-item
            v-for="(tag, i) in tags"
            :key="i"
            v-model="selectedTitle"
            :class="$style.listClss"
            @click="boardSwitch(tag)"
          >
            <v-list-item-title>{{ tag.tag_name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
    <v-col
      cols="12"
      md="12"
      sm="12"
      lg="12"
      xl="12"
      class="mt-3"
      :class="[$vuetify.breakpoint.mobile ? 'pr-1' : 'pr-10']"
    >
      <v-data-table
        v-if="showTable"
        id="virtual-scroll-table"
        v-model="selected"
        v-scroll:#virtual-scroll-table="onScroll"
        :class="
          $vuetify.breakpoint.xs ? $style.myDocTableMobile : $style.myDocTable
        "
        :headers="headers"
        :loading="loading"
        :items="documents"
        class="elevation-1"
        :must-sort="false"
        :options.sync="options"
        disable-pagination
        hide-default-footer
        no-data-text="Your Document Center is empty"
        show-select
        :single-select="false"
        item-key="document_id"
      >
        <!-- eslint-disable  -->
        <template v-slot:item.document_name="{ item }">
          <div @click="preview(item)">
            {{ item.document_name }}
          </div>
        </template>
        <template v-slot:item.document_uploaded_at="{ item }">
          <div>
            {{ formatDateMoment(item.document_uploaded_at, 'MM/DD/YYYY') }}
          </div>
        </template>
        <template v-slot:item.tags="{ item }">
          <div v-for="(tag, i) in item.tags">
            {{ tag.tag_name }}<span v-if="i < item.tags.length - 1">,</span>
          </div>
        </template>
        <!-- eslint-enable -->
        <template slot="item.actions" slot-scope="{ item }">
          <div v-if="$vuetify.breakpoint.mobile">
            <v-menu bottom left>
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon
                      class="mr-1 pa-1"
                      color="#0476d9"
                      size="18"
                      @click="editItem(item)"
                    >
                      mdi-pencil
                    </v-icon>
                    Edit
                  </v-list-item-title>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>
                    <v-icon
                      class="pa-1"
                      color="#0476d9"
                      size="18"
                      @click="deleteMultipleItems(item)"
                    >
                      mdi-delete
                    </v-icon>
                    Delete
                  </v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>

          <div v-else class="text-right">
            <v-icon
              class="mr-1 pa-1"
              color="#0476d9"
              size="18"
              @click="editItem(item)"
            >
              mdi-pencil
            </v-icon>
            <v-icon
              class="pa-1"
              color="#0476d9"
              size="18"
              @click="deleteMultipleItems(item)"
            >
              mdi-delete
            </v-icon>
          </div>
        </template>
      </v-data-table>
    </v-col>
    <v-snackbar
      v-model="snackbar"
      content-class="body--text"
      height="65"
      color="#059669"
      :timeout="3000"
    >
      <div class="d-flex">
        <v-icon color="#ffffff" class="my-auto">mdi-check-circle</v-icon>
        <div class="my-auto ml-3" style="color: #fff">
          Document(s) deleted
        </div>
      </div>
    </v-snackbar>
    <ShareHealthVaultDialogBase
      :dialog.sync="exportHealthVaultDoc"
      :selecteddocs="selected"
    ></ShareHealthVaultDialogBase>
    <UploadDocumentDialog
      v-if="openUploadDialog"
      :dialog.sync="openUploadDialog"
      :selected="selectedDocument"
      :all-tags="tags"
      :is-edit="isEdit"
      :selected-item="itemToEdit"
      @closeDialog="closeUploadDialog"
    ></UploadDocumentDialog>
    <DeleteConfirmationDialog
      :dialog.sync="openDeleteDialog"
      content="Are you sure you want to delete these documents? Shared access to these documents will also be removed."
      yes-text="Yes, proceed"
      no-text="Cancel"
      @closeDeleteDialog="closeDeleteDialog"
    ></DeleteConfirmationDialog>
  </v-row>
</template>

<style lang="scss" module>
@import '@design';
.myDocTableMobile tbody {
  tr {
    td:first-child {
      display: inline-flex !important;
      padding: 0 !important;
      margin-bottom: -60px !important;
      margin-left: -3px;
    }
  }
}
.myDocTableMobile thead {
  tr {
    th {
      padding: 0 !important;
    }
  }
}
.btnClssShowAll {
  margin-inline-start: auto;
  display: block;
}
.uploadBtn {
  padding: 0.5rem 2.2rem 0.6rem 2.2rem;
  font-size: 14px !important;
  font-weight: 400;
  color: white;
  cursor: pointer;
  background-color: #082787;
  border-radius: 3rem;
}
.uploadBtn:hover {
  background: #334d9c !important;
}
.uploadBtn:active {
  background: #06206f !important;
}
.btnClss {
  padding: 0 1.5rem !important;
  font-size: 14px !important;
  font-weight: 600 !important;
  color: #fff !important;
  text-transform: capitalize;
  background: #0476d9 !important;
  border: none;
  box-shadow: none !important;
}
.btnClssFab {
  color: #fff !important;
  background: #0476d9 !important;
}

.txtBtn {
  margin-inline-start: auto;
  display: block;
  padding: 0 !important;
  font-size: 14px !important;
  color: #0476d9 !important;
  text-transform: capitalize;
  background: none !important;
  border: none;
  box-shadow: none !important;
}
.txtBtn::before,
.listClss::before {
  content: inherit !important;
}
.listClss {
  color: #0476d9 !important;
}
.txtBtn:hover {
  background-color: none !important;
}

.btnClss:hover {
  opacity: 0.7;
}

.myDocTableMobile {
  padding: 0 15px 10px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}
.myDocTable {
  padding: 0 15px 10px;
  background: #fff;
  border: 1px solid #93c0e8;
  border-radius: 4px;
}

.myDocTable tbody {
  tr:hover {
    background-color: #f2f9ff !important;
  }
}

.uploadIcn {
  padding: 0;
  margin: 0;
  color: #fff !important;
}
</style>

<style scoped>
/deep/ .theme--light.v-data-table {
  min-height: 100px !important;
  max-height: 400px !important;
  overflow: auto !important;
}

/deep/ .v-input--selection-controls__input .v-icon {
  color: #0476d9 !important;
}

/deep/ .theme--light.v-btn.v-btn--disabled.v-btn--has-bg {
  color: #fff !important;
  background: #93c0e8 !important;
}

/deep/ .theme--light.v-btn.v-btn--disabled,
.theme--light.v-btn.v-btn--disabled .v-btn__loading,
.theme--light.v-btn.v-btn--disabled .v-icon {
  color: #fff !important;
}

@media screen and (max-width: 960px) {
  .primary-btn {
    padding: 0 !important;
  }
}
</style>
